// extracted by mini-css-extract-plugin
export default {"disableLink":"pl-z"};